/** @format */

import React from "react";
import Dictionary from "./Components/Dictionary";
const App = () => {
  return (
    <div>
      {" "}
      <Dictionary />
    </div>
  );
};
export default App;
